import { form } from '../formState'
import { useTexts } from '../../hooks/useTexts'

const companyFromNameMaxLength = 30

export function CompanyFromName() {
  const texts = useTexts()

  form.useAddFieldValidation<'companyFromName'>('companyFromName', (field, _formApi) => {
    if (!field.value.trim()) {
      return texts.companyFromNameRequired
    }

    if (field.value.length > 30) {
      return texts.companyFromNameMaxLength(companyFromNameMaxLength)
    }
  })

  return (
    <form.TextField
      label={`${texts.companyFromName} *`}
      validateOn="change"
      name="companyFromName"
      testId="companyFromName"
    />
  )
}
